function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunkStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "69px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.188,62.016C20.888,59.416 20.788,56.716 20.388,54.216C19.688,50.016 17.688,46.716 13.888,44.615C10.688,42.916 7.488,41.416 4.188,39.816C3.188,39.316 2.088,38.916 1.088,38.416C0.288,38.016 -0.212,37.316 0.088,36.416C0.288,35.816 0.988,35.416 1.488,34.916C1.588,34.816 1.788,34.816 1.988,34.816C9.888,33.216 15.188,28.116 18.788,21.316C21.988,15.416 24.588,9.216 27.488,3.216C27.888,2.316 28.288,1.416 28.788,0.716C29.088,0.316 29.888,-0.084 30.388,0.016C30.888,0.116 31.488,0.716 31.588,1.316C31.788,1.916 31.688,2.716 31.588,3.416C31.388,4.816 31.188,6.216 30.888,7.716C29.688,13.616 30.888,19.316 32.088,25.016C32.688,27.516 34.188,29.316 36.388,30.516C39.188,32.016 42.088,33.016 45.188,33.716C46.188,33.916 47.588,33.916 47.688,35.416C47.788,37.016 46.388,37.416 45.288,37.716C40.488,38.916 37.088,42.116 33.988,45.816C30.788,49.615 28.288,53.916 26.688,58.615C25.788,61.216 24.988,63.816 24.088,66.316C23.888,66.816 23.888,67.316 23.588,67.616C23.188,68.116 22.488,68.816 22.088,68.716C21.588,68.616 21.188,67.816 20.888,67.216C20.688,66.816 20.788,66.316 20.788,65.816L20.788,62.016L21.188,62.016Z",
    style: {
      fill: "rgb(08,0,102)",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunkStar);
export default __webpack_public_path__ + "static/media/funk_star.a844069abbf766db02b95e906ed8309c.svg";
export { ForwardRef as ReactComponent };